import { render, staticRenderFns } from "./RegraRoteamento.vue?vue&type=template&id=775e4836&scoped=true"
import script from "./RegraRoteamento.vue?vue&type=script&lang=js"
export * from "./RegraRoteamento.vue?vue&type=script&lang=js"
import style0 from "./RegraRoteamento.vue?vue&type=style&index=0&id=775e4836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775e4836",
  null
  
)

export default component.exports